// extracted by mini-css-extract-plugin
module.exports = {"CutCosts":"CutCosts_CutCosts__YhsT9"};